export default __webpack_public_path__ + "empty-epic-md.3987d432.svg";